"use client"
import { AVAILABLE_PLANS } from "./constants"
import { Button, Text, type ButtonProps } from "@mantine/core"
import { IconUser, IconUsersGroup } from "@tabler/icons-react"
import { useQueryState } from "nuqs"
import { useMemo } from "react"
import NextLink from "next/link"
import { useTranslations } from "next-intl"
import { planItemParser } from "../queryStates"

export function NextButton({ ...props }: ButtonProps) {
  const t = useTranslations()
  const [selectedPlan] = useQueryState("plan", planItemParser)

  const selectedPlanData = useMemo(() => AVAILABLE_PLANS.find((plan) => plan.id === selectedPlan), [selectedPlan])

  const signUpURL = useMemo(() => {
    if (selectedPlan === "team") {
      return "/sign-up/team"
    }
    return "/sign-up/solo"
  }, [selectedPlan])

  const Icon = useMemo(() => {
    if (selectedPlan === "team") {
      return IconUsersGroup
    }
    return IconUser
  }, [selectedPlan])

  return (
    <Button fullWidth {...props} size="lg" leftSection={<Icon size={18} />} component={NextLink} href={signUpURL}>
      <Text fw={500}>{selectedPlanData ? t(selectedPlanData.continueButtonText) : "Continue"}</Text>
    </Button>
  )
}
